import { Injectable } from "@angular/core";


export interface UserConfig {
  restServer: string;
}

/**
 * User Profile represents the Auth0 logged in user
 */
export interface BioConnectUser {
  user: User;
  is_curator: boolean;
}

export interface User {
  first_name: string;
  last_name: string;
  email: string;
  username: string;
}

/**
 * User Profile represents the Auth0 logged in user
 */
export interface UserProfile {
  email: string;
  name: string;
  picture: string;
  sub: string;
}

@Injectable({
    providedIn: 'root',
})

export class UserTypes {

}